import { firebase } from '../firebase-config';
import { COLLECTIONS, BaseUrl } from '../config';
import { getLoginToken } from '../storage';
import axios from 'axios';
import { collection, getDocs } from 'firebase/firestore';

/**
 * Get Issue detail by issue id
 * @param {*} id  : issueId
 * @param {*} onSuccess
 * @param {*} onError
 */
export async function getOneIssue(id, onSuccess, onError) {
  try {

    const authHeaders = { Authorization: `Bearer ${getLoginToken()}` };

    const axiosConfig = {
      headers: {
        "Content-Type": "application/json",
        withCredentials: true,
        ...authHeaders,
      },
    };

    const response = await axios.post(
      `${BaseUrl}getIssueDetails`,
      { issueId: id },
      axiosConfig
    );

    if (response.data.status) {
      const data = response.data.result;
      onSuccess && onSuccess({ status: true, data });
    } else {
      onError && onError({ status: false, error: response.data.result });
    }
  } catch (error) {
    onError && onError({ status: false, error });
  }
}

export async function getAllEmployee(onSuccess, onError) {
  try {
    const colRef = collection(firebase, COLLECTIONS.USERS);

    const querySnapshot = await getDocs(colRef);

    if (querySnapshot.empty) {
      onError && onError({ status: false, error: "No employees found" });
    } else {
      const employees = [];
      querySnapshot.forEach(doc => {
        employees.push({ id: doc.id, ...doc.data() });
      });
      onSuccess && onSuccess({ status: true, data: employees });
    }
  } catch (error) {
    onError && onError({ status: false, error });
  }
}
